import { Component, OnInit, ViewChild, OnDestroy, Input, Output, EventEmitter} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ShipOrderProduct } from 'src/app/models/fbmOrders.model';
import { FbmProductdetailsComponent } from 'src/app/modules/detail/presentational/fbm-productdetails/fbm-productdetails.component';
import { FbmOrdersService } from 'src/app/modules/fbm-orders/fbm-orders.service';
import { ScannerService } from 'src/app/services/scanner.service';

@Component({
  selector: 'app-fulfilment',
  templateUrl: './fulfilment.component.html',
  styleUrls: ['./fulfilment.component.scss']
})
export class FulfilmentComponent implements OnInit, OnDestroy {

  @ViewChild('fbmProductdetailsComponent') private fbmProductdetailsComponent!: FbmProductdetailsComponent;
  isScanning: boolean = false;
  form:FormGroup;
  searchproductList: Array<ShipOrderProduct>;
  globalSearch: string;
  scanedQty: number = 1;
  destroy: Subject<void> = new Subject<void>();

  constructor(private scannerService: ScannerService,
    private fborderService: FbmOrdersService) { }

  

  ngOnInit(): void {
    this.form=new FormGroup({
      length: new FormControl(this.shipStation.dimensions?.length,Validators.required),
      width: new FormControl(this.shipStation.dimensions?.width,Validators.required),
      height:new FormControl(this.shipStation.dimensions?.height,Validators.required),
      weight:new FormControl(this.shipStation.weight?.value,Validators.required)
    })
  }

  private _productList: Array<ShipOrderProduct> = new Array<ShipOrderProduct>();
  @Input() get productList(): Array<ShipOrderProduct> {
    return this._productList;
  }
  @Output() refresh: EventEmitter<any> = new EventEmitter();

  set productList(value) {
    this._productList = value;
    this.searchproductList = value;
  }

  private _shipStation: any;
  @Input() get shipStation() {
    return this._shipStation;
  }

  set shipStation(value) {
    this._shipStation = value;
  }

  onKeyup(event: any) {
    if (event.keyCode == 13) {
      let isVisited: boolean = false;
      this.productList.forEach((shipOrderProduct: ShipOrderProduct) => {
        let e = event.target.value;
        if ((shipOrderProduct?.name?.toLowerCase() === e?.toLowerCase() ||
          shipOrderProduct?.upc?.toLowerCase() === e?.toLowerCase()) &&
          !isVisited) {
          isVisited = true;
          shipOrderProduct.packed = (shipOrderProduct?.packed ?? 0) + this.scanedQty;
          let index = this.productList.findIndex((obj: ShipOrderProduct) => obj.name === shipOrderProduct.name);
          this.productList[index] = shipOrderProduct;
          this.fbmProductdetailsComponent.refresh();
          this.playAudio(true);
        } else if (isVisited) {

        } else {
          this.fborderService.showErrorMessage("The SKU is not valid.");
          this.playAudio(false);
        }
      });
      event.target.value = null;
    } else {
      let e = event.target.value;
      if (e) {
        this.searchproductList = this.productList
          .filter((product: ShipOrderProduct) => product.name?.toLocaleLowerCase().includes(e?.toLocaleLowerCase()));
      } else {
        this.searchproductList = this.productList;
      }
    }
  }

  setScanner(): void {
    if (this.isScanning) {
      this.scannerService.scanned
        .pipe(takeUntil(this.destroy))
        .subscribe((e) => {
          let isVisited: boolean = false;
          this.productList.forEach((shipOrderProduct: ShipOrderProduct) => {
            if ((shipOrderProduct?.name?.toLowerCase() === e?.toLowerCase() ||
              shipOrderProduct?.upc?.toLowerCase() === e?.toLowerCase()) &&
              !isVisited) {
              isVisited = true;
              shipOrderProduct.packed = (shipOrderProduct?.packed ?? 0) + this.scanedQty;
              let index = this.productList.findIndex((obj: ShipOrderProduct) => obj.name === shipOrderProduct.name);
              this.productList[index] = shipOrderProduct;
              this.fbmProductdetailsComponent.refresh();
              this.playAudio(true);
            } else if (isVisited) {

            } else {
              this.fborderService.showErrorMessage("The SKU is not valid.");
              this.playAudio(false);
            }
          });
        });
    }
  }

  private successAudio = "assets/sound/beep-08b.wav";
  private errorAudio = "assets/sound/beep-5.wav";
  private playAudio(isSuccess: boolean) {
    const audio = new Audio();
    isSuccess ? (audio.src = this.successAudio) : (audio.src = this.errorAudio);
    audio.load();
    audio.play();
  }

  ngOnDestroy(): void {
    this.destroy.next();
    this.destroy.unsubscribe();
  }

  onChange(event,dimension){
    if(dimension == 'weight'){
      this.shipStation.weight = {
       value : this.form.get('weight').value,
       units: this.shipStation.weight?.units ? this.shipStation.weight?.units : null,
       weightUnits: this.shipStation.weight?.weightUnits ? this.shipStation.weight?.weightUnits : null
      }
      this.refresh.emit({weight: this.shipStation.weight});
    }else{
      this.shipStation.dimensions = {
        length : this.form.get('length').value || null,
        height: this.form.get('height').value || null,
        width:this.form.get('width').value || null,
        units: this.shipStation.dimensions?.units ? this.shipStation.dimensions?.units : null
      }
      this.refresh.emit({dimensions: this.shipStation.dimensions});
    }
  }
}
